import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { CoreBox } from '@youscience/core';

import { sxStyles, StyledMajorCardWrap, StyledOverallFitWrap, StyledTitlesWrap } from './MajorCard.styles';

interface MajorCardSkeletonProps {
  isShowImage?: boolean;
}

export const MajorCardSkeleton = (props: MajorCardSkeletonProps) => {
  const { isShowImage } = props;

  return (
    <StyledMajorCardWrap>
      {isShowImage && <Skeleton variant="rectangular" width={296} height={183} />}

      <StyledOverallFitWrap sx={{ gap: '0.5rem' }}>
        <Skeleton variant="rounded" width={20} height={20} />

        <Skeleton variant="rounded" width={20} height={20} />

        <Skeleton variant="rounded" width={20} height={20} />
      </StyledOverallFitWrap>

      <Stack sx={sxStyles.contentWrap}>
        <StyledTitlesWrap spacing={2}>
          <Skeleton variant="rounded" width={24} height={24} />

          <Stack spacing={5} direction="column">
            <Stack spacing={1} width="90%">
              <Skeleton variant="rounded" height={16} />

              <Skeleton variant="rounded" height={16} />
            </Stack>

            <Stack spacing={1}>
              <Skeleton variant="rounded" height={22} />

              <Skeleton variant="rounded" height={22} />
            </Stack>
          </Stack>

          <Stack sx={{ paddingTop: '1rem' }}>
            <Skeleton variant="rounded" height={18} />
          </Stack>
        </StyledTitlesWrap>

        <Stack sx={sxStyles.actionsWrap} direction="row">
          <Stack sx={sxStyles.favorite} spacing={3} direction="row" alignItems="center">
            <Skeleton variant="rounded" width={25} height={20} />

            <Skeleton variant="rounded" width={25} height={20} />
          </Stack>

          <CoreBox sx={sxStyles.divider} />

          <Stack sx={sxStyles.moreWrap}>
            <Skeleton variant="rounded" width={50} height={20} />
          </Stack>
        </Stack>
      </Stack>
    </StyledMajorCardWrap>
  );
};
